import { useCallback } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import type { ChooseDoubleRewardsChoice } from '../utils/loyaltyChooseDoubleRewardsState'
import LoyaltyConfirmRewardChoiceContent from './LoyaltyConfirmRewardChoiceContent'
import useLoyaltyChooseDoubleRewardsEnrolmentState from '../hooks/useLoyaltyChooseDoubleRewardsEnrolmentState'

interface Props {
  choice: ChooseDoubleRewardsChoice
}

function LoyaltyConfirmRewardChoiceModal(props: Props) {
  const modal = useModalElementContext()
  const { pending: isEnrolmentPending } = useLoyaltyChooseDoubleRewardsEnrolmentState(props.choice)

  const dismiss = useCallback(() => {
    if (!isEnrolmentPending) {
      modal.resolve()
    }
  }, [modal, isEnrolmentPending])

  const back = useCallback(() => {
    modal.resolve()
  }, [modal])

  return <ModalBase size="S" dismissible={!isEnrolmentPending} onClose={dismiss}>
    <LoyaltyConfirmRewardChoiceContent {...props} onBack={back} />
  </ModalBase>
}

export default LoyaltyConfirmRewardChoiceModal
